<div class="nav-section-label">Scenarios</div>
<ul class="scenario-list">
	@for (scenario of scenarios(); track scenario.id) {
		<li class="scenario-row ms-3" [class.active]="scenario.id === activeScenarioService.scenarioId()">
			<button
				type="button"
				class="scenario-item"
				(click)="switchScenario(scenario.id)"
				(dblclick)="startRename(scenario.id, scenario.name, $event)"
				title="Click to switch · Double-click to rename"
			>
				@if (renamingId() === scenario.id) {
					<input
						class="rename-input"
						[ngModel]="renameValue()"
						(ngModelChange)="renameValue.set($event)"
						(click)="$event.stopPropagation()"
						(blur)="commitRename(scenario.id)"
						(keydown.enter)="commitRename(scenario.id)"
						(keydown.escape)="renamingId.set(null)"
					/>
				} @else {
					<span class="scenario-name">{{ scenario.name || 'Unnamed' }}</span>
				}
			</button>
			<div class="scenario-actions">
				<button
					type="button"
					class="scenario-action-btn"
					(click)="startRename(scenario.id, scenario.name, $event)"
					aria-label="Rename scenario"
				>
					<mat-icon>edit</mat-icon>
				</button>
				@if (scenarios().length > 1) {
					<button
						type="button"
						class="scenario-action-btn delete-btn"
						(click)="deleteScenario(scenario.id, $event)"
						aria-label="Delete scenario"
					>
						<mat-icon>close</mat-icon>
					</button>
				}
			</div>
		</li>
	}
</ul>

<div class="px-2 pb-2 mt-2">
	<button
		mat-flat-button
		color="secondary"
		type="button"
		class="w-100 new-scenario-btn"
		(click)="openNewScenarioDialog()"
	>
		<mat-icon>add</mat-icon>
		New Scenario
	</button>
</div>
